import { NavigationGuard } from 'vue-router';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

export const beforeEnterHomeInvestment: NavigationGuard = (
  _to,
  _from,
  next
) => {
  const { ENABLE_NEW_HOME_INVESTMENT_FLOW } = FeatureFlags;
  const isEnabled = FeatureFlagsModule.isEnabled(
    ENABLE_NEW_HOME_INVESTMENT_FLOW
  );

  if (isEnabled) {
    next();
  } else {
    next({ name: 'home' });
  }
};
